import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false,
  locale: "en-US",
  fallbackLocale: "en-US",
  missingWarn: true,
  fallbackWarn: true,
  warnHtmlMessage: true,
  numberFormats: {
    "en-US": {
      currency: {
        style: "currency",
        currency: "USD"
      },
      currencyDetailed: {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
      },
      currencyDtfCents: {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3, // show at least 3 decimal places including insignificant zeros
        maximumFractionDigits: 4
      },
      currencyNoCents: {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
        maximumFractionDigits: 0
      }
    },
    "en-CA": {
      currency: {
        style: "currency",
        currency: "CAD",
        currencyDisplay: "code"
      },
      currencyDetailed: {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
        currencyDisplay: "code"
      },
      currencyDtfCents: {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 3,
        maximumFractionDigits: 4,
        currencyDisplay: "code"
      },
      currencyNoCents: {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
        maximumFractionDigits: 0,
        currencyDisplay: "code"
      }
    }
  },
  datetimeFormats: {
    "en-US": {
      short: {
        month: "numeric",
        day: "numeric"
      },
      medium: {
        month: "short",
        day: "numeric",
        weekday: "long"
      },
      full: {
        month: "short",
        day: "numeric",
        year: "numeric"
      },
      month: {
        month: "short"
      },
      day: {
        day: "numeric"
      },
      weekday: {
        weekday: "long"
      }
    }
  },
  messages: {
    "en-US": {
      item: "0 items | 1 item | {count} items",
      days: "today | tomorrow | within {n} days",
      daysPast: "today | yesterday | {n} days ago",
      minute: "0 minutes | a minute | {count} minutes",
      image: "0 images | 1 image | {count} images",
      transfer: "0 Transfers | 1 Transfer | {count} Transfers",
      billingMessage: {
        customMadeAndBlanks:
          "Custom-made items (Transfers and Print) are billed immediately. Blank items are billed when shipped."
      }
    }
  }
});

export default i18n;
